export const ownDeliveryNotDeliveredOptions = [
  {
    label: "Entregador não atendido",
    value: 1
  },
  {
    label: "Cliente desconhecido no local",
    value: 2
  },
  {
    label: "Cliente mudou-se",
    value: 3
  },
  {
    label: "Cliente recusou-se a receber",
    value: 4
  },
  {
    label: "Destinatário não apresentou documento exigido",
    value: 5
  },
  {
    label: "Empresa sem expediente",
    value: 6
  },
  {
    label: "Endereço incorreto",
    value: 7
  },
  {
    label: "Logradouro com numeração irregular",
    value: 8
  },
  {
    label: "Objeto extraviado",
    value: 9
  },
  {
    label: "O entregador não finalizou a entrega",
    value: 14
  },
  {
    label: "Área de risco",
    value: 15
  },
  {
    label: "Impossibilidade de acesso ao local",
    value: 20
  },
  {
    label: "Problema no veículo",
    value: 21
  },
  {
    label: "Pedido devolvido por solicitação do remetente",
    value: 22
  },
  {
    label: "Devolvido ao remetente",
    value: 23
  },
  {
    label: "Condições climáticas adversas",
    value: 24
  },
  {
    label: "Erro na roteirização",
    value: 25
  },
  {
    label: "Mudança de modalidade",
    value: 26
  }
]

const shippingStatusNotDeliveredOptions = [
  {
    label: "Objeto não foi entregue",
    value: 6
  },
  {
    label: "Objeto Extraviado",
    value: 12
  },
  {
    label: "Não foi possível entregar o objeto",
    value: 13
  },
]

export const shippingStatusOptions = [...shippingStatusNotDeliveredOptions.map(s => s.value), 10, 5]
